<template>
	<div class="cog-checkable cog-input cog-checkable--inline" :class="{'is-read-only': readonly}">
		<div v-if="readonly">{{ displayValue || "&nbsp;" }}</div>
		<el-checkbox v-else v-model="internalValue" v-bind="$attrs" :label="label" @change="handleChange">
			{{ label }}
		</el-checkbox>
	</div>
</template>

<script>
	import '../style/_fancy-checkables.scss';

	import Vue from 'vue';
	import { Checkbox } from '@cognitoforms/element-ui';

	Vue.use(Checkbox);

	export default Vue.extend({
		name: 'CCheckbox',
		inheritAttrs: false,
		model: {
			prop: 'checked',
			event: 'change'
		},
		props: {
			label: { type: String, default: '' },
			checked: Boolean,
			readonly: Boolean,
			activeText: { type: String, default: '' },
			inactiveText: { type: String, default: '' }
		},
		data: function () {
			return {
				hasFocus: false,
				internalValue: this.checked
			};
		},
		computed: {
			displayValue() {
				return this.internalValue ? this.activeText : this.inactiveText;
			}
		},
		watch: {
			checked: function (checked) {
				this.internalValue = checked;
			}
		},
		methods: {
			handleChange(value, ev) {
				this.internalValue = value;
				this.$emit('change', value, ev);
			}
		}
	});
</script>
